import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Input } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { setUser } from "../../store/actions/authAction";
import { useHistory } from "react-router-dom";
import { filterProducts } from "../../store/actions/productAction";

const Navbar = ({ searchButton, sendValue }) => {
  const [search, setSearch] = useState("");

  const dispatch = useDispatch();
  const history = useHistory();
  const auth = useSelector((state) => state.auth);
  const products = useSelector((state) => state.product.products);

  const logOut = () => {
    localStorage.clear();
    dispatch(setUser({}));
    history.push("/login");
  };

  useEffect(() => {
    dispatch(filterProducts(search, products));
  }, [search]);

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-secondary">
      <div className="container">
        <Link className="navbar-brand" to="/products">
          <i className="fa fa-shopping-cart me-2" aria-hidden="true"></i>
          Shopping Cart
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <div className="search ms-auto">
            {searchButton && (
              <Input.Search
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                enterButton
              ></Input.Search>
            )}
          </div>
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            {!auth.isAuthenticated ? (
              <>
                <li className="nav-item">
                  <Link className="nav-link" aria-current="page" to="/login">
                    Login
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/register">
                    Register
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/explore">
                    Explore
                  </Link>
                </li>
              </>
            ) : (
              <>
                <li className="nav-item">
                  <span className="nav-link">
                    <i
                      className="fa fa-user-circle me-1"
                      aria-hidden="true"
                    ></i>
                    {auth.user.username}
                  </span>
                </li>
                <li className="nav-item">
                  <span
                    className="nav-link"
                    onClick={logOut}
                    style={{ cursor: "pointer" }}
                  >
                    Log Out
                  </span>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
